import React from "react";
import './htmlviewer.css';

// string 형태로 된 html 데이터를 element로 변환하여 반환하는 코드
const HtmlViewer = ({
    data, className
}) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
  
    const createElementFromNode = (node, key) => {
        if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent;
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
            const tagName = node.tagName.toLowerCase();
            const props = {};
            Array.from(node.attributes).forEach(attr => {
                // props[attr.name] = attr.value;
                if (attr.name === 'class') {
                    props.className = attr.value;
                } else {
                    props[attr.name] = attr.value;
                }
            });

            if (tagName === 'ul' || tagName === 'ol') {
                let indentLevel = 0;
                let parent = node.parentElement;
                while (parent) {
                    if (parent.tagName === 'UL' || parent.tagName === 'OL') {
                        indentLevel++;
                    }
                    parent = parent.parentElement;
                }

                // 체크리스트 여부 확인
                if (node.childNodes.length > 0 && node.childNodes[0].hasAttribute?.('data-checked')) {
                    const isChecked = node.childNodes[0].getAttribute('data-checked');
                    props['data-checked'] = isChecked === 'true';
                    node.setAttribute('data-checked', isChecked);
                    props.style = { ...props.style, paddingLeft: `${indentLevel * 20}px` };
                }
            }
        
            // void elements는 children을 가질 수 없으므로 self-closing 처리 ex)<br>
            const voidElements = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
            if (voidElements.includes(tagName)) {
                return React.createElement(tagName, { key, ...props });
            }
        
            const children = Array.from(node.childNodes).map((childNode, index) =>
                createElementFromNode(childNode, index)
            );
            return React.createElement(tagName, { key, ...props }, children);
        }
        return null;
    };
    
    return (
        <div className={`html-viewer ${className ?? ''}`}>
            {Array.from(doc.body.childNodes).map((node, index) => createElementFromNode(node, index))}
        </div>
    );
};

export default HtmlViewer;